<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'app',
  watch:{ // 监听路由变化，因之前跳转,页面滚动条不在起始位置,故强制回到初始位置
    '$route':function(to,from){
      if( to.path == '/' ){
        this.$store.state.isHome = true
      }else{
        this.$store.state.isHome = false
      }
      $("html, body").animate({
        scrollTop: 0
      }, {
        duration: 0,easing: "swing"
      });
    }
  },
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.bottom-line{
      display: inline-block;
    height: 3px;
    background: #fff;
    width: 37px;
    margin-top: 20px;
    position: absolute;
    right: 50%;
    margin-right: -18px;
}
.text-bg {
      background: rgb(103, 194, 58);
    margin-right: 10px;
    color: rgb(255, 255, 255);
    line-height: 32px;
    display: inline-block;
    text-align: center;
    width: 106px;
}
</style>
